import { useContext } from 'solid-js';
import type { FirstLevelMenuProps } from '../../../menu-types';
import removeAmpersand from '../../../../../tools/remove-ampersand';
import { ChevronRightIcon } from '../../../../icons-library/chevron-right';
import { AppContext } from '../../../../../app-context-provider/app-context-provider';

export const FirstLevelMenu = (props: FirstLevelMenuProps) => {
    const { localize } = useContext(AppContext);

    return (
        <li class="flex flex-col pb-0">
            <button
                class="group flex items-center gap-cvi-5 w-full min-h-cvi-touch-min p-cvi-4 cursor-pointer bg-transparent border-0 text-left"
                onClick={() => props.onDrillIn(props.parent)}
                aria-label={localize('open-submenu', 'Open Submenu')}
            >
                <span class="flex-1 min-w-0 label-lg font-cvi-medium text-cvi-fg-default transition-colors duration-200 group-hover:text-cvi-fg-link">
                    {removeAmpersand(props.parent.title)}
                </span>
                <span class="flex items-center justify-center size-cvi-8 shrink-0 text-cvi-fg-link">
                    <ChevronRightIcon ariaLabel={localize('open-submenu', 'Open Submenu')} />
                </span>
            </button>
        </li>
    );
};
